var _dec, _dec2, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from "@ember-data/model";
import JournalEvent from "core/models/journal-event";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateNumber, validatePresence } from "ember-changeset-validations/validators";
import { IntlService } from "ember-intl";
let BaseSurgerySurveyFilledJournalEvent = (_dec = attr("number"), _dec2 = attr("string"), _class = class BaseSurgerySurveyFilledJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "score", _descriptor, this);
    _initializerDefineProperty(this, "originTaskIdentifier", _descriptor2, this);
  }
  static baseValidations(intl) {
    return {
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.survey-filled-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })],
      score: validateNumber({
        allowBlank: true,
        description: intl.t("validations.survey-filled-journal-event.score")
      })
    };
  }
  computeSectionsWithColor(sections, scoreValues) {
    const computeAnswers = key => {
      return [this.intl.t(`ctcae-custom.${key}.answers.${this[key]}`)];
    };
    const computeColor = value => {
      return value >= 100 ? "red" : value >= 10 ? "orange" : "green";
    };
    const computeLabel = key => {
      return this.intl.t(`ctcae-custom.${key}.short`);
    };
    return [...sections.map(key => ({
      key,
      label: computeLabel(key),
      color: computeColor(scoreValues[key][this[key]]),
      answers: computeAnswers(key)
    })), ...(this.score ? [{
      key: "score",
      label: "Score",
      color: computeColor(this.score),
      answers: [this.score.toString()]
    }] : [])];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "score", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "originTaskIdentifier", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { BaseSurgerySurveyFilledJournalEvent as default };